import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Modal from '@/assets/common/Modal/Modal.vue';
import {DestinationGroupDetail,DestinationGroup,ShippingDestinationList} from "@/types/Component"

const initDestinationGroup: DestinationGroupDetail = {
    id: null,
    name: '',
    shippingDestinations: []
}

@Component({
    components: {
        Modal,
        Multiselect,
    }
})

export default class DestinationGroupModal extends Vue {
    
    private modalTitle = '出荷先グループ新規作成'
    private destinationGroup : DestinationGroupDetail =initDestinationGroup;
    private shippingDestinations: ShippingDestinationList[] = []
    private isLoading = true

    @Prop()
    private value!: boolean
    @Prop({ default: null })
    private groupId!: string
    @Prop({
        default: () => "/admin/shipping_destinations"
    })
    declare apiPath: string;

    @Watch('showDestinationGroupModal')
    private async onChangeShowDestinationGroupModal() {
        this.isLoading = true
        if (this.showDestinationGroupModal) {
            this.modalTitle = '出荷先グループ新規作成'
            this.destinationGroup = {
                id: null,
                name: '',
                shippingDestinations:[]
            }
            this.shippingDestinations= await this.getDestinations();
            if (this.groupId !== null) {
                const group = await this.getGroup(this.groupId)
                this.destinationGroup = {
                    id: null,
                    name: group.name,
                   shippingDestinations :this.shippingDestinations.filter(af => group.destinations_id.includes(af.id))
                }
                this.modalTitle = '出荷先グループ編集'
            }
        }
        this.isLoading = false
    }

    get showDestinationGroupModal(): boolean {
        return this.value
    }

    set showDestinationGroupModal(value: boolean) {
        this.value
    }

    private  async getDestinations(): Promise<ShippingDestinationList[]> {
        const res = await this.$apiClient.doRequest('get', `/shippingDestinationGroupdetails/destinationGroup/${this.groupId}`)
        return res.shipping_destinations
    }

    private success(word: '保存' | '削除') {
        this.$toasted.success(`${word}しました。`)
        return true
    }
    
    private error(word: '保存' | '削除') {
        this.$toasted.error(`${word}に失敗しました。`)
        return false
    }

    @Emit('save')
    async save(): Promise<any> {
        // 名前の長さチェック
        if(this.destinationGroup.name.length > 100) {
            window.alert(`圃場グループ名は100文字以内で入力してください（現在は${this.destinationGroup.name.length}文字）`)
            return false
        }
        const reqData = {
            name: this.destinationGroup.name,
            shipping_destinations: this.destinationGroup.shippingDestinations.map(af => af.id),
        }
        if (this.groupId === null) {
            const close = await this.$apiClient.doRequest('post', '/shippingDestinationGroupdetails/admin/destination_groups/', reqData)
                .then(() => this.success('保存'))
                .catch(() => this.error('保存'))

            if(close) {
                this.destinationGroup = initDestinationGroup
            }
            return close
        }
        else {
            const close = await this.$apiClient.doRequest('put', `/shippingDestinationGroupdetails/admin/destination_groups/${this.groupId}`, reqData)
                .then(() => this.success('保存'))
                .catch(() => this.error('保存'))

            if(close) {
                this.destinationGroup = initDestinationGroup
            }
            return close
        }
    }

    @Emit('cancel')
    cancel(): boolean {
        this.destinationGroup = initDestinationGroup
        return true
    }

    get isValid(): boolean {
        const nameValid = !!this.destinationGroup.name
        const desitinationsValid = this.destinationGroup.shippingDestinations.length > 0
        return nameValid && desitinationsValid
    }

    private async getGroup(id: string) {
        const group = await this.$apiClient.doRequest('get', `/shippingDestinationGroupdetails/admin/destination_groups/${id}`)
        return group
    }
}
